import React, { useState,useEffect } from "react";
import "../styles/css/NavBar.css";

function NavBar() {
  const [navIsOpen, setNavIsOpen] = useState(false);

  const [isMoving, setIsMoving] = useState(false);

  useEffect(function () {
    console.log(3)
    setIsMoving(true)
    setTimeout(() => setIsMoving(false), 1000);
  }, [navIsOpen])
  return (
    <div>
      <nav>
        <div className={`navbar flex-container ${navIsOpen ? "open" : ""}`}>
          <ul className="unstyled-list flex-container normal-font">
            <li className="to-left nav-link">Explore</li>
            <li className="to-right nav-link">Categories</li>
            <li className="nav-link">New Deals </li>
          </ul>
        </div>
        <div className={`burger-div ${isMoving? "moving": "" }`}>
          <div
            className="burger"
            onClick={() => setNavIsOpen((prev) => !prev)}
          ></div>
        </div>
      </nav>
    </div>
  );
}

export default NavBar;
